export var Race;
(function (Race) {
    Race["Asian"] = "Asian";
    Race["Black"] = "Black";
    Race["Multiple"] = "Multiple";
    Race["NativeAmerican"] = "NativeAmerican";
    Race["NativePacificIsles"] = "NativePacificIsles";
    Race["Unknown"] = "Unknown";
    Race["White"] = "White";
})(Race || (Race = {}));
//# sourceMappingURL=Race.js.map